import React from "react"
import { RouteComponentProps } from "@reach/router"
import { IFrame } from "./iframe"
import { usePolicyAndFleet } from "../contexts"
import { LowConnectivityBanner } from "../ui/components/LowConnectivityBanner"

export const Billing: React.FC<RouteComponentProps> = () => {
  const { policy, connectivity } = usePolicyAndFleet()

  const urlParams = new URLSearchParams(window.location.search)
  const searchParams: Record<string, string> = {}

  const from = urlParams.get(`from`)
  const to = urlParams.get(`to`)

  if (from) searchParams.from = from
  if (to) searchParams.to = to

  return (
    <>
      {!!(connectivity.data || policy.connectivityRatio) && <LowConnectivityBanner policy={policy} />}
      <IFrame path={`policies/${policy.id}/billing`} searchParams={searchParams} />
    </>
  )
}
